
/*
 *
 */
export function CssVariable(element, name, unit = null) {
    this.element = element;
    this.name = name;
    this.unit = unit;
}

CssVariable.prototype.get = function() {
    const style = window.getComputedStyle(this.element);
    const value = style.getPropertyValue(`--${this.name}`);

    return value;
}

CssVariable.prototype.set = function(value) {
    const style = this.element.style;

    if (typeof value === 'number') {
        value = Math.round(value * 10000) / 10000;
    }

    if (this.unit !== null) {
        value += this.unit;
    }

    style.setProperty(`--${this.name}`, value);

    return this;
}

/*
 *
 */
export function Visibility(element, options = { }) {
    this.element = element;
    this.options = { ...options };

    this.observer = new IntersectionObserver(VisibilityEventHandler(this), this.options);
    this.observer.observe(this.element);

    this.listeners = { };
}

const VisibilityEventHandler = (instance) => function(entries) {
    for (const entry of entries) {
        if (entry.isIntersecting) {
            instance.trigger('viewport:enter', entry);
        } else {
            instance.trigger('viewport:leave', entry);
        }
    }
}

Visibility.prototype.trigger = function(name, event) {
    if (name in this.listeners === false) {
        return;
    }

    for (const listener of this.listeners[name]) {
        listener.call(this.element, event);
    }
};

Visibility.prototype.on = function(name, callback) {
    if (name in this.listeners === false) {
        this.listeners[name] = [ ];
    }

    this.listeners[name].push(callback);
};

// async function waitForAnimationFrame() {
//     return new Promise(r => requestAnimationFrame(r));
// }
